import { useContext } from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';
import { saveAds, saveAdsWithMetadata } from '@bingads-webui-campaign-react/display-plus-native-ads';

import { getDefaultCampaign, getDefaultAdGroup } from './constants';
import { useAdsRepository } from '../../common/use-ads-repository';

export const useNativeAdRepository = () => {
  const i18n = useContext(I18nContext);

  const serverContext = useContext(ServerContext);
  const isVideoAsAnAssetEnabled = serverContext.Permissions && serverContext.DynamicPermissions.VideoAsAnAsset && !serverContext.Permissions.IsAmplifyEnabled;

  const { load, save } = useAdsRepository({
    saveAds: isVideoAsAnAssetEnabled ? saveAdsWithMetadata : saveAds,
    defaultCampaign: getDefaultCampaign(i18n, serverContext),
    defaultAdGroup: getDefaultAdGroup(i18n, serverContext),
  });

  return {
    load,
    save,
  };
};
